import PropTypes from "prop-types";
import React from "react";
import MDBox from "../MDBox";

function ValidationHint({ valid, validAnswer, ...boxProps }) {
  return (
    <MDBox sx={{ fontSize: "1.8rem", mt: 2 }} {...boxProps}>
      {valid === 1 && <MDBox color="success">Bravo ! Tu as trouvé la bonne réponse !</MDBox>}
      {valid === 2 && (
        <MDBox color="error">
          Faux ! {(validAnswer || validAnswer === 0) && "La bonne réponse était : " + validAnswer}
        </MDBox>
      )}
      {valid !== 1 && valid !== 2 && <MDBox>&nbsp;</MDBox>}
    </MDBox>
  );
}
ValidationHint.propTypes = {
  valid: PropTypes.number,
  validAnswer: PropTypes.any,
};

export default ValidationHint;
